<script>
  import { fade } from "svelte/transition";
</script>

<div class="overlay" transition:fade={{ delay: 0, duration: 300 }}>
  <h3>Loading .......</h3>
</div>

<style>
  .overlay {
    margin: 0px;
    width: 100%;
    height: 200px;
    background-color: rgb(11, 84, 84);
    opacity: 0.4;
    text-align: center;
  }
</style>
